export default __webpack_public_path__ + "media/images/portfolio/gallery-06-1200x869_original-db4f1b86bca109caa796af7583071ee6.jpg";